module.exports = __webpack_public_path__ + "static/img/fullscreen-image_easy-to-get-started.b0e7c1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/job-description-generator/fullscreen-image_easy-to-get-started.png
// module id = TvSr
// module chunks = 0